// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H4V20H7V5H12V20H15V11H20V20H22V22H2V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.5322 3.4668L23.5693 4.75L20.5322 6.03223L19.25 9.06934L17.9668 6.03223L14.9307 4.75L17.9668 3.4668L19.25 0.430664L20.5322 3.4668Z"}}]};

const AiChartBarFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai-chart-bar-filled',
    ref,
    icon: element,
  },
));

AiChartBarFilledIcon.displayName = 'AiChartBarFilledIcon';

export default AiChartBarFilledIcon;
